var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"expression-editor",staticClass:"ignore-key-press",style:(_vm.editorStyle),on:{"keydown":function($event){$event.stopPropagation();}}})])}
var staticRenderFns = []

export { render, staticRenderFns }